import React, { useEffect, useState } from 'react';
import './SectionPlayList.scss';
import CardPlay from './CardPlay';
import { useDataLayerValue } from '../../DataLayer';
import { db } from '../../firebase';
import { Link, useHistory } from 'react-router-dom';


function SectionPlayList(props) {
    const [{ lang }] = useDataLayerValue();
    const [listPlaylist, setListPlaylist] = useState([]);
    let history = useHistory();
    useEffect(() => {
        if (props.item.playlists_id && props.item.playlists_id.length > 0) {
            let startArr = 0;
            let endArr = 10;
            let arrIdUpdateTmp = [];
            let arrPlaylistUpdateTmp = [];
            let arrTmp = [...props.item.playlists_id];
            let lengthArr = arrTmp.length;
            let totalFor = Math.ceil(lengthArr / 10);
            for (let i = 0; i < totalFor; i++) {
                let arrSlice = arrTmp.slice(startArr, endArr);
                startArr = endArr;
                endArr = endArr + 10;
                db.collection("playlists").where("status", "==", true).where('key', 'in', arrSlice)
                    .get()
                    .then(function (querySnapshot) {
                        arrPlaylistUpdateTmp = [...arrPlaylistUpdateTmp, ...querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))]
                        arrIdUpdateTmp = [...arrIdUpdateTmp, ...querySnapshot.docs.map(doc => (doc.id))];
                        if (i === totalFor - 1) {
                            setListPlaylist([...arrPlaylistUpdateTmp]);
                        }
                    })
                    .catch(function (error) {
                        console.log("Error getting playlist song: ", error);
                        history.push('/error');
                    });
            }
        } else {
            setListPlaylist([]);
        }
    }, []);
    return (
        <section className="Root__right-container__section">
            <div className="container__section--title__warp">
                <div className="container__section--title__warp--left">
                    <h2 className="container__section--title__top">
                        <Link to={`genre/${props.item.id}`} draggable="false" className="container__section--title__top-a" href="">{lang == 'en' ? props.item.name_en : props.item.name_vi}</Link>
                    </h2>
                </div>
                <Link to={`genre/${props.item.id}`} draggable="false" className="container__section--title__warp--right">
                    <span className="" as="span">{lang === 'en' ? 'See all' : 'Xem thêm'}</span>
                </Link>
            </div>
            <div className="container__section--list-card">
                {
                    listPlaylist.map((item, index) => (
                        <Link to={`playlist/${item.id}`} key={index}>
                            <CardPlay key={index} idPlaylist={item.id ? item.id : ''} title={lang == 'en' ? item.name_en : item.name_vi} subtitle={lang == 'en' ? item.subtitle_en : item.subtitle_vi} image={item.avatar ? item.avatar : ''} />
                        </Link>
                    ))
                }
            </div>
        </section>
    );
}

export default SectionPlayList;